module.exports = __webpack_public_path__ + "img/tubro-min.f521ad42.png";